export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/equinix2-b3025842dc0c01b40f66837089febc00.png";